import React, { useState } from 'react';
import EmojiPicker from './EmojiPicker';

const ReplyForm = ({ currentUser, onSubmitReply, onCancel }) => {
  const [replyText, setReplyText] = useState('');
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!replyText.trim()) return;
    
    onSubmitReply(replyText);
    setReplyText('');
  };
  
  const handleEmojiSelect = (emoji) => {
    setReplyText(prev => prev + emoji);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex gap-2 items-start"
    >
      {currentUser.profile_image ? (
        <img
          src={currentUser.profile_image}
          alt="user"
          className="w-8 h-8 rounded-full object-cover"
        />
      ) : (
        <div className="w-8 h-8 rounded-full bg-purple-500 text-white flex items-center justify-center font-semibold text-sm">
          {currentUser.name?.charAt(0).toUpperCase() || 'U'}
        </div>
      )}
      
      <div className="flex-1 flex flex-col">
        <div className="relative flex items-center border rounded-full w-full py-2 px-4 text-sm focus-within:ring-1 focus-within:ring-blue-500">
          <input
            type="text"
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
            placeholder="Add a reply..."
            className="flex-1 outline-none bg-transparent"
          />
          <button
            type="button"
            onClick={() => setShowEmojiPicker(!showEmojiPicker)}
            className="text-gray-500 hover:text-gray-700 ml-2"
            aria-label="Add emoji"
          >
            😊
          </button>
          
          {showEmojiPicker && (
            <EmojiPicker
              onEmojiSelect={handleEmojiSelect}
              onClose={() => setShowEmojiPicker(false)}
              position="bottom"
            />
          )}
        </div>

        <div className="flex justify-end mt-2 space-x-2">
          <button
            type="button"
            onClick={onCancel}
            className="text-gray-600 text-sm px-3 py-1 rounded-md hover:bg-gray-100 transition-colors"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={!replyText.trim()}
            className="bg-blue-600 text-white text-sm px-3 py-1 rounded-md hover:bg-blue-700 disabled:bg-blue-300 disabled:cursor-not-allowed transition-colors"
          >
            Reply
          </button>
        </div>
      </div>
    </form>
  );
};

export default ReplyForm;